import { post } from "../../utils/Backend";
import { getOrFetchApiCache } from "../../utils/ApiSessionCache";
import { mockListConcepts, mockSearchConceptStocks } from "./ConceptMock";
import type {
  ConceptBrief,
  ConceptSearchParams,
  ConceptStockRow,
} from "./ConceptType";

/** 改为 `mock && false` 可走真实网关 */
export const mock = true && false;

const BASE = "/lark/app/concept";

function assertResult<T>(res: T | string): T {
  if (typeof res === "string") {
    throw new Error(res);
  }
  return res;
}

function conceptCatalogCacheKey(spaceProductId: string): string {
  return `concept:catalog:${spaceProductId.trim()}`;
}

export const ConceptApi = {
  listConcepts: async (spaceProductId: string): Promise<ConceptBrief[]> => {
    const pid = spaceProductId.trim();
    if (!pid) {
      return [];
    }
    return getOrFetchApiCache(conceptCatalogCacheKey(pid), async () => {
      if (mock) {
        return mockListConcepts();
      }
      const raw = await post<{ spaceProductId: string }, ConceptBrief[]>(
        `${BASE}/listConcepts`,
        { spaceProductId: pid },
        { silent: true }
      );
      return assertResult(raw);
    });
  },

  searchStocks: async (params: ConceptSearchParams): Promise<ConceptStockRow[]> => {
    if (mock) {
      return mockSearchConceptStocks(params);
    }
    const raw = await post<ConceptSearchParams, ConceptStockRow[]>(
      `${BASE}/searchStocks`,
      params,
      { silent: true }
    );
    return assertResult(raw);
  },
};
